import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { DateControl } from "@tiny/components";
import { useStyles } from "../Value.styles";

interface DateRangeValueProps {
  prefixName: string;
  disabled?: boolean;
}

function DateRangeFullValue(props: DateRangeValueProps) {
  const { prefixName, disabled } = props;

  const classes = useStyles();

  const value = useWatch({
    name: `${prefixName}.value`,
  });

  const { trigger } = useFormContext();

  const nameFrom = `${prefixName}.value.value[0]`;

  const nameTo = `${prefixName}.value.value[1]`;

  const validateTo = (v: number | string | null) => {
    if (typeof v === "number" && !isNaN(v)) {
      if (value?.value?.[0] > v) {
        return "Before from";
      }
    }
  };

  React.useEffect(() => {
    trigger([nameFrom, nameTo]);
  }, [trigger, nameFrom, nameTo, value]);

  return (
    <div className={classes.root}>
      <DateControl
        name={nameFrom}
        className={classes.field}
        placeholder="From"
        aria-label="Condition from"
        showHelperTextMargin
        required
        disabled={disabled}
        openTo="year"
        views={["year", "month", "day"]}
      />
      <DateControl
        name={nameTo}
        className={classes.field}
        placeholder="To"
        aria-label="Condition to"
        showHelperTextMargin
        required
        validate={validateTo}
        disabled={disabled}
        openTo="year"
        views={["year", "month", "day"]}
      />
    </div>
  );
}

export default DateRangeFullValue;
